<template>
  <div>
    <Header></Header>
    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div class="row">
          <div class="col-md-8">
            <div class="section-row">
              <div class="section-title">
                <h2 class="title">Dúvidas, opiniões? Fale conosco!</h2>
              </div>
              <p>Escolha a melhor maneira para nos mandar uma mensagem.</p>
              <ul class="contact">
                <li>
                  <i class="fa fa-phone"></i>
                  <a href="tel:551932312811" rel="noreferrer">19 3231-2811</a>
                </li>
                <li>
                  <i class="fa fa-envelope"></i>
                  <a href="mailto:contato@pedline.org.br" rel="noreferrer"
                    >contato@pedline.org.br</a
                  >
                </li>
                <li>
                  <i class="fa fa-map-marker"></i> Rua Delfino Cintra, 63 -
                  Centro <br />CEP: 13013-055 Campinas, SP
                </li>
              </ul>
            </div>

            <div class="section-row">
              <div class="section-title">
                <h2 class="title">Envie-nos uma mensagem aqui mesmo</h2>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <input
                      class="input"
                      v-model="contact.name"
                      type="text"
                      placeholder="Nome"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <input
                      class="input"
                      v-model="contact.email"
                      type="email"
                      placeholder="Informe seu e-mail"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <input
                      class="input"
                      v-model="contact.subject"
                      type="text"
                      placeholder="Assunto"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <textarea
                      class="input"
                      v-model="contact.message"
                      placeholder="Sua mensagem"
                    ></textarea>
                  </div>

                  <transition enter-active-class="animated fadeIn">
                    <p style="color:#29b715;" v-show="contactSent">
                      Mensagem enviada. Obrigado pelo contato.
                    </p>
                  </transition>

                  <transition enter-active-class="animated fadeIn">
                    <p style="color:#f00;" v-show="warningMessage != ''">
                      {{ warningMessage }}
                    </p>
                  </transition>

                  <button @click="sendContact" class="primary-button">
                    <div v-show="!loading">ENVIAR</div>
                    <div v-show="loading" class="loading-spinner"></div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <Newsletter></Newsletter>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <Footer></Footer>
  </div>
</template>
<script>
import http from "@/http";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Newsletter from "../components/Newsletter";
import validators from "../util/validators";

export default {
  name: "Contato",
  components: {
    Header,
    Footer,
    Newsletter
  },
  data() {
    return {
      contact: {
        name: "",
        email: "",
        subject: "",
        message: ""
      },
      loading: false,
      contactSent: false,
      warningMessage: ""
    };
  },
  methods: {
    sendContact() {
      if (this.contact.name == "") {
        this.warningMessage = "Por favor, informe o seu nome.";
        return;
      }

      if (this.contact.email == "") {
        this.warningMessage = "Por favor, informe o seu e-mail.";
        return;
      }

      if (!validators.validateEmail(this.contact.email)) {
        this.warningMessage = "Por favor, informe um e-mail válido.";
        return;
      }

      if (this.contact.subject == "") {
        this.warningMessage = "Por favor, informe um assunto.";
        return;
      }

      if (this.contact.message == "") {
        this.warningMessage = "Por favor, digite sua mensagem.";
        return;
      }

      this.warningMessage = "";
      this.loading = true;

      http
        .post("contact", this.contact)
        .then(() => {
          this.contactSent = true;
          this.contact = {
            name: "",
            email: "",
            subject: "",
            message: ""
          };
        })
        .catch(err => {
          console.log(err);
          this.contactSent = false;
          this.warningMessage =
            "Algo deu errado. Por favor, tente novamente em alguns instantes.";
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style>
textarea {
  resize: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Contato.vue